<ts-ai-available-models
  [isCloud]="data.isCloud"
  [modelSelected]="data.modelSelected"
  (submitted)="close($event)"
>
</ts-ai-available-models>
